import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const FilmStreamingService = () => {
  return (
    <IndustryPageTemplate
      title="Film Streaming"
      subtitle="Watch and enjoy a wide range of movies"
      desc="Watch and enjoy a wide range of movies, web series, and exclusive shows in stunning quality. Access premium content from independent creators and major studios globally."
      image="https://images.unsplash.com/photo-1616530940355-351fabd9524b?q=80&w=1000&auto=format&fit=crop"
      themeColor="#07a4f5"
      bgGradient="linear-gradient(135deg, rgba(7,164,245,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "Interactive Post Feed",
    "desc": "Engage with dynamic media containers, rich text, and multimedia posts right on your timeline."
  },
  {
    "title": "Story & Video Uploads",
    "desc": "Use our built-in Story Upload Camera and Voice Recorder to share authentic moments instantly."
  },
  {
    "title": "Expressive Reactions",
    "desc": "Interact with content using our custom Reaction Picker and Audio Message bubbles."
  },
  {
    "title": "Location Previews",
    "desc": "Discover global content contextually with integrated interactive Location Preview Modals."
  }
]}
    />
  );
};

export default FilmStreamingService;
